Librarian.Cart.Window = new Class({
    Implements: Events,
    Extends: Librarian.Window,
    Binds: [
        "updateCart", "doUpdate", "doRefresh", "onResize", "onBeforeCreatePackage",
        "changeView", "downloadCart", "cleanCartList", "setTextReplace",
        "onBeforeSaveFavorite", "saveAsFavorite", "reload", "addSection", "onViewClick"
    ],

    options: {
        cartContainer: "cartTileList",
        wrapperClass: "tile-list-wrapper-cart",
        id: "cartWindow",
        height: 565,
        width: 845,
        toolbar: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        },
        maximizable: true,
        resizable: true
    },

    // Path to the layout
    path: '',
    // Whether the toolbar has been loaded already or not
    toolbarLoaded: false,
    // Information about the collapse state for the toolbar
    toolbarInfo: {
        collapsed: false,
        leftWidth: null,
        rightWidth: null
    },
    // Whether or not we are displaying sections
    hasSections: false,
    // The tileList object for the cart
    cartList: null,
    // The createPackage object for the cart
    // Used to close this window when the cart is closed.
    createPackage: null,
    // The saveFavorite object for the cart
    // Used to close this window when the cart is closed.
    saveFavorite: null,
    onVPCreated: null,
    onVPCatCreated: null,
    // Text replace data to be passed along into the create window
    textReplaces: null,
    // Extra fields data to be passed along into the create window
    extraFields: null,
    // Optional override to use instead of cart data
    dataOverride: null,

    /*
     * Initializes an instance of the Cart window with the given options and event handler functions
     *
     * options - Option overrides
     * onVPCreatedFn - A function run when a My Favorite is created
     * onVPCatCreatedFn - A function run when a My Favorite category is created
     */
    initialize: function(options, onVPCreatedFn, onVPCatCreatedFn) {
        this.setOptions(options);

        // window type either default or modal
        if(Librarian.cart.openAsModalWindow) {
            this.options.type = "modal";
        }

        this.updateTitle();

        this.onVPCreated = onVPCreatedFn;
        this.onVPCatCreated = onVPCatCreatedFn;

        // Get the path to the layout
        this.path = Librarian.path.getLayoutsPath();

        // Load the cart page
        this.options.contentURL = this.path + "/pages/cart.html";

        // Set the toolbar URL
        this.options.toolbarURL = Librarian.path.getLibraryPath() + "toolbar-cart.html";

        // Handle hiding/showing text in toolbar buttons when resizing and maximizing
        this.options.onResize = this.onResize;
        this.options.onMaximize = this.onResize;
        this.options.onRestore = this.onResize;

        this.setWindowPosition();

        this.parent(this.options);
    },

    //#region Window Event Handlers

    /*
     * Handles the window resizing
     * This is currently used to expand/collapse the buttons on the toolbar to fit the window width
     */
    onResize: function() {
        // We only care about the window resizing when the buttons are supposed to automatically
        // switch between small and large icons
        if (!Librarian.cart.enableLabelSquishing)
            return;

        var toolbarWidth = this.toolbarEl.getWidth(),
            leftBarEl = this.toolbarEl.getElement(".toolbox-left"),
            rightBarEl = this.toolbarEl.getElement(".toolbox"),
            buttonEls = this.toolbarEl.getElements(".ico-cart-wrapper"),
            menuLabelEls = this.toolbarEl.getElements(".dropdown-menu-bar > li > a"),
            leftWidth,
            rightWidth;

        // If we have a previously saved width of the left bar, use that
        if (typeof this.toolbarInfo.leftWidth == "number")
            leftWidth = this.toolbarInfo.leftWidth;
        // Otherwise calculate the current width
        else
            leftWidth = leftBarEl ? leftBarEl.getWidth() : 0;

        // If we have a previously saved width of the right bar, use that
        if (typeof this.toolbarInfo.rightWidth == "number")
            rightWidth = this.toolbarInfo.rightWidth;
        // Otherwise calculate the current width
        else
            rightWidth = rightBarEl ? rightBarEl.getWidth() : 0;

        // If the two bars are larger than their parent, they need to be collapsed
        if (Librarian.cart.hideButtonLabels || ((rightWidth + leftWidth) > toolbarWidth)) {
            // Set collapse state
            this.toolbarInfo.collapsed = true;
            this.toolbarInfo.leftWidth = leftWidth;
            this.toolbarInfo.rightWidth = rightWidth;

            buttonEls.forEach(function (buttonEl) {
                if (!buttonEl.hasClass("hide-icon"))
                    buttonEl.addClass("hide-text");
            });

            menuLabelEls.forEach(function(label) {
                label.addClass("hide-text");
            });
        }
        // Otherwise, if this is already collapsed then we need to expand it
        else if (this.toolbarInfo.collapsed) {
            // Remove collapse state
            this.toolbarInfo.collapsed = false;
            this.toolbarInfo.leftWidth = null;
            this.toolbarInfo.rightWidth = null;

            buttonEls.forEach(function (buttonEl) {
                buttonEl.addClass("hide-text");
            });

            menuLabelEls.forEach(function(label) {
                label.removeClass("hide-text");
            });
        }
    },

    /*
     * Handles setting up the toolbar buttons when it has finished loading the first time
     */
    onToolbarLoaded: function () {
        // Don't do this stuff more than once
        if (this.toolbarLoaded)
            return;

        this.parent();

        if (Librarian.cart.convertButtonsToMenu)
            this.buildCartMenu();

        var libraryPath = Librarian.path.getLibraryPath(),
            iconsPath = Librarian.path.getDefaultThemePath() + "images/icons/",
            buttonEl = $("updateCart");
        // If the remove button is there
        if (buttonEl) {
            // Set the correct icon
            buttonEl.src = libraryPath + "img/updateCart.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.updateCart);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("clearCart");
        var imageEl = $("clearCartImage");
        // If the clear button is there
        if (buttonEl) {
            // Set the correct icon
            if (imageEl)
                imageEl.src = libraryPath + "img/clearCart.gif";
            else
                buttonEl.src = libraryPath + "img/clearCart.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.clearCart);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("sendCart");
        // If the clear button is there
        if (buttonEl) {
            if (!Librarian.Cart.canSend() || Librarian.Utils.isUserMemberOfGroup(Librarian.cart.disableShareUserGroups))
                buttonEl.destroy();
            else {
                // Set the correct icon
                if (buttonEl.tagName == "IMG")
                    buttonEl.src = libraryPath + "/img/send.gif";
                // Add the onclick method
                buttonEl.addOnClick(Librarian.Cart.sendCart);
                // And update the ID
                buttonEl.id = this.options.id + '_' + buttonEl.id;
            }
        }

        buttonEl = $("sendNewsletter");
        // If the clear button is there
        if (buttonEl) {
            if (!Librarian.Cart.canSend())
                buttonEl.destroy();
            else {
                // Set the correct icon
                if (buttonEl.tagName == "IMG")
                    buttonEl.src = libraryPath + "/img/send.gif";
                // Add the onclick method
                buttonEl.addOnClick(function() {
                    Librarian.Cart.sendCart(Librarian.eventType.newsletter);
                });
                // And update the ID
                buttonEl.id = this.options.id + '_' + buttonEl.id;
            }
        }

        buttonEl = $("changeView");
        // If the clear button is there
        if (buttonEl) {
            if (Librarian.cart.allowDisplaySwitch) {
                // Set the correct icon
                buttonEl.src = iconsPath + "SmallThumbnailView.png";
                var name = "cart_view_slide";

                if (Librarian.userCart && Librarian.userCart.isInSlideView()) {
                    buttonEl.src = iconsPath + "FileView.png";
                    name = "cart_view_mixed";
                }

                // Add the onclick method
                buttonEl.addOnClick(this.changeView);
                // And update the ID
                buttonEl.id = this.options.id + '_' + buttonEl.id;
                // And update the mouse over
                buttonEl.alt = buttonEl.title = Librarian.Lang.getArgString("cart_view_button", [Librarian.Lang.getString(name)]);
            }
            else {
                var parentEl = buttonEl.getParent();
                buttonEl.destroy();

                if (parentEl && parentEl.hasClass("ico-cart-wrapper"))
                    parentEl.destroy();
            }
        }

        buttonEl = $("refreshThumb");
        if (buttonEl) {
            // Set the correct icon
            buttonEl.src = this.path + "/img/Refresh.png";
            // Add the onclick method
            buttonEl.addOnClick(this.doRefresh);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("downloadCart");
        imageEl = $("downloadCartImage");
        // If the download button is there
        if (buttonEl) {
            // Set the correct icon
            if (imageEl)
                imageEl.src = libraryPath + "img/create.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.downloadCart);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("saveFavorite");
        imageEl = $("saveFavoriteImage");
        // If the save button is there
        if (buttonEl) {
            // Set the correct icon
            if (imageEl)
                imageEl.src = libraryPath + "img/save.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.saveAsFavorite);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("saveSlideShow");
        imageEl = $("saveSlideShowImage");
        // If the save button is there
        if (buttonEl) {
            // Set the correct icon
            if (imageEl)
                imageEl.src = libraryPath + "img/save.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.saveAsFavorite.pass([Library.refreshSlideShowTree, Library.refreshSlideShowTree, null, null, Librarian.virtPresType.slideshow]), this);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("saveSharedFavorite");
        imageEl = $("saveSharedFavoriteImage");
        // If the save button is there
        if (buttonEl) {
            // Set the correct icon
            if (imageEl)
                imageEl.src = libraryPath + "img/save.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.saveAsFavorite.pass([Library.refreshSharedFavTree, Library.refreshSharedFavTree, null, null, Librarian.virtPresType.sharedFavorite]), this);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("saveSharedSlideShow");
        imageEl = $("saveSharedSlideShowImage");
        // If the save button is there
        if (buttonEl) {
            // Set the correct icon
            if (imageEl)
                imageEl.src = libraryPath + "img/save.gif";
            // Add the onclick method
            buttonEl.addOnClick(this.saveAsFavorite.pass([Library.refreshSharedSlideShowTree, Library.refreshSharedSlideShowTree, null, null, Librarian.virtPresType.sharedSlideshow]), this);
            // And update the ID
            buttonEl.id = this.options.id + '_' + buttonEl.id;
        }

        buttonEl = $("addSectionButton");
        imageEl = $("addSectionImage");
        if (buttonEl) {
            if (Librarian.features.sections.load) {
                // Set the correct icon
                if (imageEl)
                    imageEl.src = Librarian.path.getLibraryPath() + "img/Add-Section.gif";
                // Add the onclick method
                buttonEl.addOnClick(this.addSection, this);
                // And update the ID
                buttonEl.id = this.options.id + '_' + buttonEl.id;
            }
            else
                buttonEl.destroy();
        }

        buttonEl = $("cartViewDropdown");
        if (buttonEl) {
            // Create the list of views to switch between if the library defines them
            if (typeof Library.getCartViews == "function")
                this.createViewDropdown(buttonEl, Library.getCartViews());
            else
                buttonEl.destroy();
        }

        // Show/hide send buttons based on items
        this.updateSendButtons();

        // Loading complete
        this.toolbarLoaded = true;
        // Run the onResize so that the toolbar has the correct sizes and stuff now
        this.onResize();
        Librarian.Lang.translateElements(this.windowEl);
    },

    buildCartMenu: function () {
        // Create menu
        var toolboxEl = this.toolbarEl.getElement(".toolbox"),
            menuWrapperEl = new Element("div", { id: "cartMenuDropdown", "class": "dropdown-menu-wrapper" }).inject(toolboxEl),
            ulEl = new Element("ul", { "class": "dropdown-menu-bar" }).inject(menuWrapperEl),
            liEl = new Element("li").inject(ulEl),
            linkEl = new Element("a", { "class": "ico-dot-menu" }).inject(liEl),
            menuEl = new Element("div").inject(liEl);

        // Move buttons into menu
        var buttonEls = this.toolbarEl.getElements(".ico-cart-wrapper");
        buttonEls.forEach(function (buttonEl) {
            // Handle the create button separately
            if (buttonEl.id.contains("downloadCart") && !Librarian.cart.createInMenu) {
                // Hide icon
                buttonEl.addClass("hide-icon");
                buttonEl.removeClass("ico-cart-wrapper");

                // Style as button
                var textEl = buttonEl.firstElementChild;
                if (textEl) {
                    textEl.addClass("pure-button");
                    textEl.removeClass("ico-cart-label");
                }

                return;
            }

            // Get menu text from inner element or button title
            var itemEl = buttonEl.getElement("a");
            var text = (itemEl && itemEl.get("text")) || buttonEl.title;
            if (!text)
                return;

            // Add new element to menu with same id as button
            var menuItemEl = new Element("a", {
                id: buttonEl.id,
                text: text
            }).inject(menuEl);

            buttonEl.destroy();
        });

        Librarian.Utils.bindSDDMMenus([{ parent: linkEl, menu: menuEl }]);
    },

    /*
     * Handles loading the list of cart data after the window has loaded
     * Also sets up an override of the minimize button to reset the window to its initial position, but only when the `useMinimizeAsReset` setting is enabled
     */
    onWindowLoaded: function () {
        this.parent();

        // If the minimize button is being overridden
        if (Librarian.cart.useMinimizeAsReset) {
            var buttonEl = $(this.options.id + "_minimizeButton");
            // Get the button
            if (buttonEl) {
                // Remove the default event
                buttonEl.removeEvents(Librarian.hasTouchSupport() ? "touchstart" : "click");
                // When the button is clicked, set the position to the default
                buttonEl.addOnClick(this.setWindowPosition, this);
            }
        }

        // Display the list of slides
        this.reload();
    },

    /*
     * Handles cleaning up of the window elements when it is closed
     */
    onClose: function() {
        // Run the update function to clear out deleted items.
        this.doUpdate();

        if (this.createPackage) {
            this.createPackage.closeWindow();
            this.createPackage = null;
        }

        if (this.saveFavorite) {
            this.saveFavorite.close();
            this.saveFavorite = null;
        }

        this.cleanCartList();
        this.parent();
    },

    //#endregion

    //#region View Change Dropdown

    /*
     * Creates a dropdown to allow the user to switch between the available cart views
     *
     * menuContainerEl - The DOM element to create the dropdown menu in
     * views - The list of views to create within the dropdown
     */
    createViewDropdown: function(menuContainerEl, views) {
        var viewContainerEl = new Element("ul", { "class": "views-dropdown dropdown-menu-bar" }).injectInside(menuContainerEl),
            viewListEl = new Element("li").injectInside(viewContainerEl),
            triggerEl = new Element("a").injectInside(viewListEl),
            menuEl = new Element("div", { id: this.options.id + "_viewMenu" }).injectInside(viewListEl);

        // Create the dropdown menu handler for the created menu
        Librarian.Utils.bindSDDMMenus([{ parent: triggerEl, menu: menuEl }]);

        // Add each view to the dropdown list
        for (var i = 0; i < views.length; i++) {
            if (views[i].cart === false)
                continue;

            var text = Librarian.Lang.getString(views[i].name),
                selected = false;
            if (typeof views[i].selected == "function")
                selected = views[i].selected();
            else if (typeof views[i].selected == "boolean")
                selected = views[i].selected;

            var itemEl = new Element("a", {
                "id": views[i].id,
                "title": text,
                "class": "ico-view-item"
            });

            var iconEl = new Element("span", {
                    "class": views[i]["class"] + "-icon ico-view-item",
                    "title": "",
                "text": ""
            }).injectInside(itemEl);

            itemEl.viewIndex = i;
            itemEl.appendChild(document.createTextNode(text));

            // If this is the first item or it is explicitly selected, make it show inside the trigger element
            if (selected || i == 0) {
                triggerEl.set("title", text);
                triggerEl.appendChild(document.createTextNode(text));
                triggerEl.removeClass(views[0]["class"]);
                triggerEl.addClass(views[i]["class"]);
            }

            itemEl.addOnClick(this.onViewClick);
            menuEl.appendChild(itemEl);
        }

        menuEl = null;
        triggerEl = null;
        viewListEl = null;
        viewContainerEl = null;
    },

    /*
     * Handles when an item in the views dropdown is clicked
     * Automatically updates the selected view in the dropdown and the cart item tile size in each inner TileList
     *
     * e - The event containing information such as which element was clicked
     */
    onViewClick: function(e) {
        if (!e || (typeof Library.getCartViews != "function") || !this.cartList)
            return;

        var evt = new Event(e),
            buttonEl = $(evt.target);
        if (!buttonEl)
            return;

        function setTileListSize(size) {
            this.cartList.reload(size);
            Librarian.Utils.updateCheckboxes(this.cartList.getItemStyle());

            var triggerEl = $$("#cartViewDropdown .views-dropdown li a")[0];
            if (!triggerEl)
                return;

            var views = Library.getCartViews(),
                view = views[buttonEl.viewIndex],
                text = Librarian.Lang.getString(view.name);

            triggerEl.set("title", text);
            Librarian.Utils.setElementValue(triggerEl, text);
            var hideText = triggerEl.hasClass("hide-text");

            triggerEl.className = '';
            triggerEl.addClass(view["class"]);
            if (hideText)
                triggerEl.addClass("hide-text");
        }

        if (buttonEl.id.endsWith("tnailSm"))
            setTileListSize.bind(this)('');
        else if (buttonEl.id.endsWith("tnailLg"))
            setTileListSize.bind(this)("lg");
        else if (buttonEl.id.endsWith("detailedList"))
            setTileListSize.bind(this)("expand");
    },

    //#endregion

    //#region Button Handlers

    /*
     * Clears the cart contents and resets the locally saved text replace data
     *
     * Returns false
     */
    clearCart: function() {
        Librarian.Cart.clearCart();
        return false;
    },

    /*
     * Prompts the user asking whether they want to update the cart which removes items marked for deletion
     *
     * Returns false
     */
    updateCart: function(cancelOnUpdateCall) {
        // If there is no cart, there is nothing to update.
        if (!Librarian.userCart) { return false; }

        // Get the number of items to be removed.
        var count = null;
        if(this.cartList) {
            count = this.cartList.getUnCheckedElements().length;
        }
        
        // get number of unchecked cart items
        if (count === 0) {
            // no unchecked items, just reload
            this.reload(); 
        } else {
            if(!(Librarian.features.fastlane.load && Librarian.FastLane.isEnabled)) {
                // Make sure the user wants to do this first
                var confirm = new Librarian.ConfirmWindow({
                    id: "updateCartConfirmWindow",
                    title: Librarian.Lang.getString("update") + '?',
                    question: Librarian.Lang.getString("cart_update?")
                });
                confirm.onFirstButtonClicked = function() {
                    this.doUpdate(count);
                }.bind(this);
                confirm.show();
            } else {
                // skip confirmation window with fastlane enabled

                // if cancelOnUpdateCall, tells cart to not fire 'onUpdate' function after cart update
                // (allows cart module to update cart window without infinate loop)
                if(cancelOnUpdateCall === null) { cancelOnUpdateCall = false; }
                this.doUpdate(count, cancelOnUpdateCall);
            }

        }

        return false;
    },

    /*
     * Runs the update function which removes all cart items marked for deletion and notifies the user how many were removed
     *
     * Returns false
     */
    doUpdate: function(count, cancelOnUpdateCall) {
        // If there is no cart, there is nothing to update.
        if (!Librarian.userCart) {
            return false;
        }

        // default value is false
        if(cancelOnUpdateCall === null) {
            cancelOnUpdateCall = false;
        }

        // Update the cart
        Librarian.userCart.removeAllDeleted();

        // Reload this window to display the updated list
        this.reload();

        // Tell the user how many items were removed
        if (count != undefined) {
            Librarian.Utils.notification(Librarian.Lang.getPluralArgString("cart_removed", count, [count]));
        }

        if(!cancelOnUpdateCall) {
            // If items were removed, fire onUpdate
            if (((count == undefined) || (count > 0)) && Librarian.userCart.onUpdate) {
                Librarian.userCart.onUpdate();
            }
        }

        // Update the checkboxes on the main page
        Librarian.Utils.updateAllCheckboxes();

        return false;
    },

    /*
     * Toggles the cart between SLIDE view and MIXED view
     *
     * Returns false
     */
    changeView: function() {
        // If there isn't a cart, don't bother continuing
        if (!Librarian.userCart)
            return false;

        // Get the changeView button
        var buttonEl = $(this.options.id + "_changeView"),
            iconsPath = Librarian.path.getDefaultThemePath() + "images/icons/";

        // If we're in Mixed View, go to Slide View
        if (Librarian.userCart.isInMixedView()) {
            Librarian.userCart.changeView(Librarian.Cart.displayModes.SLIDE_VIEW);

            if (buttonEl) {
                buttonEl.src = iconsPath + "FileView.png";
                buttonEl.alt = buttonEl.title = Librarian.Lang.getArgString("cart_view_button", [Librarian.Lang.getString("cart_view_mixed")]);
            }
        }
        // Otherwise, go to Mixed View
        else {
            Librarian.userCart.changeView(Librarian.Cart.displayModes.MIXED_VIEW);

            if (buttonEl) {
                buttonEl.alt = buttonEl.title = Librarian.Lang.getArgString("cart_view_button", [Librarian.Lang.getString("cart_view_slide")]);
                buttonEl.src = iconsPath + "SmallThumbnailView.png";
            }
        }

        // Reload this window to display the newly updated list
        this.reload();

        return false;
    },

    /*
     * Causes the cart list to reload its thumbnails
     *
     * Returns false
     */
    doRefresh: function() {
        if (this.cartList)
            this.cartList.reloadThumbnails();

        return false;
    },

    /*
     * Reloads the cart window by completely removing the existing list and regenerating it over again
     */
    reload: function() {
        var contEl = $(this.options.cartContainer);
        // If the container and the cart each exist
        if (contEl && Librarian.userCart) {
            // Add the cartList to the container if we don't have one already
            if (!this.cartList || (this.hasSections == (Librarian.userCart.sections.length == 0))) {
                var size = null;
                if (this.cartList)
                    size = this.cartList.options.size;

                this.cleanCartList();
                contEl.empty();

                this.initCartList(size);
            }

            // If we're using sections, load them into the list
            if (this.hasSections) {
                this.cartList.reset();
                var sections = Librarian.userCart.getSectionsList(true, Librarian.cart.showDuplicates);
                for (var i = 0; i < sections.length; i++)
                    this.cartList.addSection(sections[i].items, sections[i].name, sections[i].description);
            }
                // Otherwise load the display items into the cart list
            else
                this.cartList.loadFromArray(Librarian.userCart.getDisplayItems(true, Librarian.cart.showDuplicates));

            // Update the count in the title
            this.updateTitle();
            this.updateSendButtons();
        }
    },

    /*
     * Initialize the cart list
    */
    initCartList: function(size) {
        if (Librarian.features.sections.load && (Librarian.userCart.sections.length > 0)) {
            this.cartList = new Librarian.SectionList({
                container: $(this.options.cartContainer),
                sectionClassPrefix: "section-cart-",
                tileListStyle: "tile-list-item-cart",
                size: size,
                allowDrag: true,
                allowEdit: true,
                allowHeaderDrag: true
            });
            this.cartList.options.targetList = tileList;

            this.hasSections = true;
        }
        else {
            this.cartList = new Librarian.TileList({
                id: "cartTileListWrapper",
                container: $(this.options.cartContainer),
                itemStyle: "tile-list-item-cart",
                size: size,
                allowDrag: true,
            });
            this.cartList.options.targetList = tileList;

            this.hasSections = false;
        }
    },

    //#endregion

    /*
     * Adds a new empty section with the default name and description
     */
    addSection: function() {
        if (!Librarian.features.sections.load || !Librarian.userCart)
            return;

        Librarian.userCart.addSection();
        this.reload();
    },

    //#endregion

    //#region Package Creation

    /*
     * Runs checks before opening the create window to determine whether creation should be allowed
     * If data is not provided, this will check to make sure there are things in the cart to create
     * Also creates the package creation instance to handle the creation process
     *
     * event - The event containing information such as which element was clicked - Optional
     * data - The data being created, if not using the cart - Optional
     *
     * Returns true if creation is allowed, false otherwise
     */
    onBeforeCreatePackage: function(event, data) {
        // Can't download an empty cart
        if ((typeof data == "undefined") || (data == null)) {
            if (Librarian.userCart) {
                if (Librarian.userCart.getCount(true, true) == 0)
                    return false;
                if (Librarian.userCart.isFull()) {
                    Librarian.Utils.error(Librarian.Lang.getString("cart_overfull"));
                    return false;
                }
            }
        }
        else
            this.dataOverride = data;

        // Create a new createPackage item if there isn't one already
        if (this.createPackage == null)
            this.createPackage = new Librarian.CreatePackage();

        return true;
    },

    /*
     * Opens the create package window for the user to fill out and begin the create process
     *
     * event - The event containing information such as which element was clicked - Optional
     * data - The data being created, if not using the cart - Optional
     * windowOptions - Additional options to pass to the create package window - Optional
     *
     * Returns false
     */
    downloadCart: function(event, data, windowOptions) {
        // Check to make sure this should be allowed first
        if (!this.onBeforeCreatePackage(event, data))
            return false;

        // If we have extra properties we need to pass to the cart form
        if (this.textReplaces || this.extraFields) {
            // Make sure we have a data object
            if (!data)
                data = {};
            // And a data object within the data object
            if (!data.data)
                data.data = null;
            // And an options object
            if (!data.options)
                data.options = {};
            // And then save the given text replaces
            if (this.textReplaces) {
                data.options.textReplaces = this.textReplaces;
            }
            // And then save the given extra fields
            if (this.extraFields) {
                data.options.extraFields = this.extraFields;
            }
        }

        windowOptions = windowOptions || {};
        windowOptions.createOptions = Object.merge({}, windowOptions.createOptions, this.createOptions);

        // Show the createPackage window
        this.createPackage.showWindow(data, windowOptions);

        // Center the window element.
        var windowEl = this.createPackage.getWindow();
        if (windowEl)
            MUI.centerWindow(windowEl);

        return false;
    },

    /*
     * Causes the create package window to update its button status based on changed cart content
     */
    updateCreateWindow: function() {
        if ((this.createPackage == null) || (this.createPackage.window == null))
            return;

        this.createPackage.window.updateOutputButtons();
    },

    //#endregion

    //#region Favorite Creation

    /*
     * Runs checks before opening the save favroite window to determine whether saving a favorite should be allowed
     * Is usually overridden on a per-library basis
     *
     * Returns true
     */
    onBeforeSaveFavorite: function() {
        return true;
    },

    /*
     * Opens the save favorite window for the user to fill out and begin the saving process
     *
     * onVPCreatedFn - A function run when a My Favorite is created. Overrides the function given when the cart window was created - Optional
     * onVPCatCreatedFn - A function run when a My Favorite category is created. Overrides the function given when the cart window was created - Optional
     * defaultName - The name to default this favorite to in the save form
     * saveEmpty - Whether to allow saving a favorite even when the cart is empty - Optional, defaults to false
     * type - The type of favorite being saved
     */
    saveAsFavorite: function(onVPCreatedFn, onVPCatCreatedFn, defaultName, saveEmpty, type) {
        // Can't save an empty cart
        if (!this.onBeforeSaveFavorite() || ((this.dataOverride == null) && (saveEmpty !== true) && Librarian.userCart && (Librarian.userCart.getCount(true, true) == 0))) {
            Librarian.Utils.notification(Librarian.Lang.getString("cart_is_empty"));
            return false;
        }

        this.saveFavorite = new Librarian.MyFavorite.SaveWindow({ defaultName: defaultName, presType: type, data: this.dataOverride });
        this.saveFavorite.onCreated = typeof onVPCreatedFn == "function" ? onVPCreatedFn : this.onVPCreated;
        this.saveFavorite.onCatCreated = typeof onVPCatCreatedFn == "function" ? onVPCatCreatedFn : this.onVPCatCreated;
        this.saveFavorite.show();

        return false;
    },

    //#endregion

    //#region Helper Functions

    /*
     * Sets the position and size of this window based on various settings
     */
    setWindowPosition: function() {
        // Make sure to un-maximize the window
        this.restore();

        // If we are trying to open this at a non-standard position
        if (Librarian.cart.defaultPosition != null) {
            var mode = Librarian.cart.positions.center;

            // Get the mode, if it's provided
            if (Librarian.cart.defaultPosition.mode != null && !isNaN(Librarian.cart.defaultPosition.mode))
                mode = Librarian.cart.defaultPosition.mode;

            // Get the size of the window
            var windowDimensions = window.getCoordinates(),
                // Get the total height used by all toolbars, et al
                extraHeight = (this.options.toolbar ? this.options.toolbarHeight : 0) +
                    (this.options.toolbar2 ? this.options.toolbar2Height : 0) +
                    this.options.headerHeight + this.options.footerHeight + (this.options.shadowBlur * 2);

            // Stick the window to the bottom
            if (mode == Librarian.cart.positions.bottom)
                this.options.y = windowDimensions.height - this.options.height - extraHeight;
            else {
                // Set the height of the cart window to the height of the browser minus the height of all the window's extra stuff
                this.options.height = windowDimensions.height - extraHeight;

                // Set the y position if it's provided and subtract that from the window's height
                if (Librarian.cart.defaultPosition.y != null && !isNaN(Librarian.cart.defaultPosition.y)) {
                    this.options.y = Librarian.cart.defaultPosition.y;
                    this.options.height -= this.options.y;
                }
                // Otherwise just move the window to the top so it will fit
                else
                    this.options.y = 0;
            }

            if (Librarian.cart.defaultPosition.width != null) {
                // Set the width if it's provided as a number
                if ((typeof Librarian.cart.defaultPosition.width == "number") && (Librarian.cart.defaultPosition.width > 0))
                    this.options.width = Librarian.cart.defaultPosition.width;
                // If it's provided as a percent, calculate that instead
                else if ((typeof Librarian.cart.defaultPosition.width == "string") && Librarian.cart.defaultPosition.width.endsWith('%')) {
                    var percent = parseInt(Librarian.cart.defaultPosition.width, 10) / 100;
                    if (percent > 0)
                        this.options.width = windowDimensions.width * percent;
                }
            }

            if (Librarian.cart.defaultPosition.height != null) {
                var calcHeight = null;
                // Set the height if it's provided as a number
                if ((typeof Librarian.cart.defaultPosition.height == "number") && (Librarian.cart.defaultPosition.height > 0))
                    calcHeight = Librarian.cart.defaultPosition.height;
                // If it's provided as a percent, calculate that instead
                else if ((typeof Librarian.cart.defaultPosition.height == "string") && Librarian.cart.defaultPosition.height.endsWith('%')) {
                    var percent = parseInt(Librarian.cart.defaultPosition.height, 10) / 100;
                    if (percent > 0)
                        calcHeight = windowDimensions.height * percent;
                }

                // Set the height if it's provided and smaller than the previously calculated height
                if (calcHeight < this.options.height)
                    this.options.height = calcHeight;
            }

            // Set the position to the right, if that's the chosen mode
            // Subtract an extra 20 off the end to make room for the scroll bar, just in case
            if ((mode == Librarian.cart.positions.right) || (Librarian.cart.defaultPosition.right == true))
                this.options.x = windowDimensions.width - this.options.width - this.options.shadowBlur - 20;
        }

        // If the window is already open
        if (this.toolbarLoaded) {
            // Resize/reposition it
            this.resize({
                width: this.options.width,
                height: this.options.height,
                top: this.options.y,
                left: this.options.x,
                centered: false
            });

            this.onResize();
        }
    },

    /*
     * Updates the title of this window based on settings and the number of items in the cart
     * Also updates the name of the window on the dock tabs
     */
    updateTitle: function() {
        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("cart");

        // Show the slide count
        if (Librarian.cart.showCountInTitle)
            this.options.title += " - " + Librarian.Lang.getArgString("cart_count", [Librarian.userCart.getCount(Librarian.cart.showSlideCount, true)]);

        var itemEl = $(this.options.id + "_title");
        if (itemEl) {
            itemEl.set("text", MUI.getFittedTitle(this.options.title, this.options.width));
            itemEl.title = this.options.title;
        }

        // Update the title of the dock tab for hover over
        itemEl = $(this.options.id + "_dockTab");
        if (itemEl)
            itemEl.title = this.options.title;

        // Update the text inside of the dock tab
        itemEl = $(this.options.id + "_dockTabText");
        if (itemEl)
            itemEl.set("text", this.options.title);
    },

    /*
     * Updates the send buttons based on whether the items in the cart can be sent
     */
    updateSendButtons: function() {
        var canSend = Librarian.Cart.canSendItems();

        var sendEl = this.getElement("sendCart");
        if (sendEl)
            sendEl.toggle(canSend);

        var newsletterEl = this.getElement("sendNewsletter");
        if (newsletterEl)
            newsletterEl.toggle(canSend);
    },

    /*
     * Determines whether this cart window is currently visible
     */
    isVisible: function() {
        return (this.windowEl.style.visibility == "visible") || (this.windowEl.style.visibility == '') || this.isMinimized;
    },

    /*
     * Sets or adds to the locally saved list of text replace values
     *
     * textReplaces - Values to be set or added to the local list
     * clearExisting - Whether to clear the existing list before adding the given list
     */
    setTextReplace: function(textReplaces, clearExisting) {
        this.textReplaces = (clearExisting === true) ? textReplaces : Object.merge(this.textReplaces || {}, textReplaces);
    },

    /*
     * Sets or adds to the locally saved list of text replace values
     *
     * extraFields - Values to be set or added to the local list
     * clearExisting - Whether to clear the existing list before adding the given list
    */
    setExtraFields: function(extraFields, clearExisting) {
        this.extraFields = (clearExisting === true) ? extraFields : Object.merge(this.extraFields || {}, extraFields);
    },

    setCreateOptions: function (createOptions, clearExisting) {
        this.createOptions = (clearExisting === true) ? createOptions : Object.merge(this.createOptions || {}, createOptions);
    },

    /*
     * Cleans the window's cart list by completely destroying it
     */
    cleanCartList: function() {
        if (this.cartList) {
            this.cartList.destroy();
            this.cartList = null;
        }
    }

    //#endregion
});
